export const buildTabScopeKey = ({
  targetId,
  tabId,
  pageKey = tabId,
}: {
  targetId: string | null | undefined;
  tabId: string;
  pageKey?: string;
}): string =>
  targetId
    ? `targetId_${targetId}/tabId_${tabId}/pageKey_${pageKey}`
    : `tabId_${tabId}/pageKey_${pageKey}`;
